import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";

const HERO = "https://static.prod-images.emergentagent.com/jobs/933edf10-af87-41b6-8124-d5da806634cd/images/b29474af16e8767abf3fd55ea159051a117ef79244ef542b550c79188cfd0633.jpeg";

export function AuthLayout({ title, subtitle, children, footer }) {
  return (
    <div className="grid min-h-screen lg:grid-cols-2">
      <div className="flex flex-col justify-center px-6 py-10 sm:px-12 lg:px-16">
        <div className="mx-auto w-full max-w-sm">
          <Logo />
          <h1 className="mt-8 font-display text-2xl font-extrabold tracking-tight text-slate-900 sm:text-3xl">{title}</h1>
          {subtitle && <p className="mt-2 text-sm text-slate-500">{subtitle}</p>}
          <div className="mt-8">{children}</div>
          {footer && <div className="mt-6 text-center text-sm text-slate-500">{footer}</div>}
        </div>
      </div>
      <div className="relative hidden overflow-hidden bg-gradient-to-br from-[#5B21B6] via-[#6D28D9] to-[#8B5CF6] lg:block">
        <div className="pointer-events-none absolute -right-16 -top-16 h-72 w-72 rounded-full bg-white/10 blur-3xl" />
        <div className="flex h-full flex-col justify-center px-14 text-white">
          <img src={HERO} alt="" className="mx-auto w-72 rounded-3xl bg-white/10 p-2 backdrop-blur" />
          <h2 className="mt-8 font-display text-3xl font-extrabold leading-tight">From Dream to Destination.</h2>
          <p className="mt-3 max-w-sm text-purple-100">Ubah cita-cita studi ke luar negeri menjadi langkah yang jelas, terukur, dan bisa dilacak.</p>
          <div className="mt-8 flex gap-6 text-sm">
            <div><div className="font-display text-2xl font-extrabold">500+</div><div className="text-purple-200">Beasiswa</div></div>
            <div><div className="font-display text-2xl font-extrabold">50+</div><div className="text-purple-200">Negara</div></div>
            <div><div className="font-display text-2xl font-extrabold">95%</div><div className="text-purple-200">Kepuasan</div></div>
          </div>
        </div>
      </div>
    </div>
  );
}
